import * as React from "react";
import { BrComponent } from "@bloomreach/react-sdk";
import { generateConditionalClassNames } from "../../../../utils/containers/RowComponent/utils/utils.js";
/* empty css               */
const CmsRowColumn = ({ component }) => {
  const { showInDesktop, showInTablet, showInPhone, fullWidth, ...cssStyles } = component.getParameters();
  const filteredStyles = Object.fromEntries(
    Object.entries(cssStyles).filter(([_, value]) => value !== "")
  );
  const columnClassName = generateConditionalClassNames("br-column", {
    showInDesktop,
    showInTablet,
    showInPhone
  });
  return /* @__PURE__ */ React.createElement("div", { className: columnClassName, "data-t": "br-column", style: { ...filteredStyles } }, /* @__PURE__ */ React.createElement(BrComponent, null));
};
export {
  CmsRowColumn,
  CmsRowColumn as default
};
//# sourceMappingURL=RowColumn.js.map
